export default function CExtern() {
  return <h2>C Extern</h2>;
}
